__turbopack_context__.v({
  "hamburger": "mobile-module__C1pEHG__hamburger",
  "hamburgerDarkBg": "mobile-module__C1pEHG__hamburgerDarkBg",
  "menuItem": "mobile-module__C1pEHG__menuItem",
  "mobileNavDropdown": "mobile-module__C1pEHG__mobileNavDropdown",
  "mobileNavTitle": "mobile-module__C1pEHG__mobileNavTitle",
});
